"use client";

import type { FormEvent, ReactNode, Ref } from "react";
import { withToast } from "./toast";

// A <form> whose server action shows a Done/Failed toast on completion.
// Drop-in replacement for `<form action={serverAction}>` in the admin UI.
export function ActionForm({
  action,
  children,
  className,
  ref,
  onInput,
}: {
  action: (formData: FormData) => unknown | Promise<unknown>;
  children: ReactNode;
  className?: string;
  /** For callers that need to read the form's own validity (see OfferForm). */
  ref?: Ref<HTMLFormElement>;
  onInput?: (e: FormEvent<HTMLFormElement>) => void;
}) {
  return (
    <form
      ref={ref}
      onInput={onInput}
      action={withToast(action)}
      className={className}
    >
      {children}
    </form>
  );
}
